import { request } from '@langlois/request';

export async function createDocument ({ commit, getters }, { competitionId, data }) {
	try {
		const body = new FormData();

		for (let [key, value] of Object.entries(data)) {
			if (value) body.append(key, value);
		}

		const { clubId } = getters[`getById`](competitionId);

		const url = new URL(`${process.env.VUE_APP_API_URI}/club/club/${clubId}/document`);

		const response = await request.post(url, body);

		if (response.ok) {
			const document = await response.json();

			const competitionDocumentUrl = new URL(`${process.env.VUE_APP_API_URI}/club/competition/${competitionId}/document`);

			const competitionDocumentBody = new FormData();

			competitionDocumentBody.append(`documentVersionId`, document.versionId);
			competitionDocumentBody.append(`competitionId`, competitionId);

			const competitionDocumentResponse = await request.post(competitionDocumentUrl, competitionDocumentBody);

			if (competitionDocumentResponse.ok) {
				const competitionDocumentId = (await competitionDocumentResponse.json()).id;

				commit(`addDocument`, {
					competitionId,
					document: {
						...data,
						competitionDocumentId,
						...document
					}
				});
			}
		}
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while creating the document.`,
			type: `warning`
		}, { root: true });
	}
}
